module.exports = __webpack_public_path__ + "image-8266afd71b08.png";